import { useMemo } from 'react'

import { Swiper, SwiperSlide } from 'swiper/react'
// import required modules
import { Autoplay, Pagination } from 'swiper/modules'
import Image from 'next/image'
import { Skeleton } from '@nextui-org/react'
import Link from 'next/link'

import { useGetBannerQuery } from '@/redux/api/banner'
import { cn } from '@/utils/cn'

const SiderQC = ({ isMobile }: { isMobile?: boolean }) => {
  const { data: banner, isFetching } = useGetBannerQuery({ key: 'BANNER_SIDEBAR' })

  const pagination = {
    clickable: true,
    renderBullet: function (index: number, className: string) {
      return `<span class='${className}'></span>`
    },
  }
  const bannerData = useMemo(() => {
    if (isMobile) {
      return (banner || []).filter((o: { mediaMobileUrl: any }) => o?.mediaMobileUrl)
    }
    return (banner || []).filter((o: any) => o?.mediaUrl)
  }, [banner])

  return (
    <div className={cn('grid overflow-hidden', !isMobile && 'rounded-xl border border-white/10')}>
      <Swiper
        autoplay={{
          delay: 3000,
        }}
        slidesPerView={1}
        pagination={pagination}
        modules={[Pagination, Autoplay]}
        className="event-swipper w-full"
      >
        {isFetching ? (
          <SwiperSlide>
            <Skeleton className="rounded-lg">
              <div className={cn('h-[450px] bg-default-300', !isMobile && 'rounded-lg')}></div>
            </Skeleton>
          </SwiperSlide>
        ) : (
          bannerData?.map(({ mediaUrl, title, urlRedirect, mediaMobileUrl }: any, i: number) => (
            <SwiperSlide key={i} className="w-full">
              <div className={cn('relative block', isMobile ? 'aspect-[375/180]' : 'aspect-[312/492]')}>
                {urlRedirect ? (
                  <Link href={urlRedirect} passHref legacyBehavior>
                    <a target="_blank" rel="noopener noreferrer">
                      <Image fill src={isMobile ? mediaMobileUrl : mediaUrl} sizes="100vw" quality={100} alt={title} />
                    </a>
                  </Link>
                ) : (
                  <Image fill src={isMobile ? mediaMobileUrl : mediaUrl} sizes="100vw" quality={100} alt={title} />
                )}
              </div>
            </SwiperSlide>
          ))
        )}
      </Swiper>
    </div>
  )
}

export default SiderQC
